import { render, staticRenderFns } from "./ModalDevolverItem.vue?vue&type=template&id=a378ef8c&"
import script from "./ModalDevolverItem.vue?vue&type=script&lang=js&"
export * from "./ModalDevolverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports